export default "__VITE_ASSET__N$HWDHjh__"